var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicle-image"},[(_vm.linkEnabled)?_c('a',{attrs:{"href":_vm.buildUrl('vehicles/' + _vm.instance.id + '/overview')}},[_c('vehicle-image-inner',{attrs:{"instance":_vm.instance}})],1):_c('vehicle-image-inner',{attrs:{"instance":_vm.instance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }